function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsxs as W, jsx as m } from "react/jsx-runtime";
import * as o from "react";
import { assignInlineVars as w } from "@vanilla-extract/dynamic";
import { useIsomorphicLayoutEffect as L } from "./hooks.js";
import { ButtonSecondary as B, ButtonDanger as M, ButtonPrimary as x } from "./button.js";
import { BUTTON_MIN_WIDTH as C } from "./button.css-mistica.js";
import h from "classnames";
import { debounce as O } from "./utils/helpers.js";
import { getPrefixedDataAttributes as N } from "./utils/dom.js";
import { baseContainer as R, alignVariant as S, fullWidthContainer as k, container as A, noButtonWidth as D, alignMoreThanOneChildred as I, vars as T, link as V, linkAlignment as _, margins as j } from "./button-layout.css-mistica.js";
const z = (t)=>{
    o.useEffect(()=>{
        var r, u;
        let e = !1;
        return (u = (r = document.fonts) == null ? void 0 : r.ready) != null && u.then && document.fonts.ready.then(()=>{
            e || t();
        }), ()=>{
            e = !0;
        };
    }, [
        t
    ]);
}, P = (t, e)=>{
    o.useEffect(()=>{
        if (t) {
            const r = new MutationObserver(e);
            return r.observe(t, {
                childList: !0,
                attributes: !1,
                subtree: !0
            }), ()=>{
                r.disconnect();
            };
        }
        return ()=>{};
    }, [
        e,
        t
    ]);
}, p = [
    B,
    M,
    x
], F = (param)=>{
    let { children: t , align: e = "full-width" , link: r , withMargins: u = !1 , dataAttributes: b  } = param;
    const v = o.Children.count(t), [s, y] = o.useState({
        isMeasuring: !0,
        buttonWidth: 0
    }), f = (param)=>{
        let { isMeasuring: i , buttonWidth: a  } = param;
        process.env.NODE_ENV !== "test" && y({
            isMeasuring: i,
            buttonWidth: a
        });
    }, c = o.useRef(null);
    L(()=>{
        if (s.isMeasuring && c.current) {
            const i = Array.from(c.current.children).map((d)=>d.dataset.link ? 0 : d.offsetWidth + 1), a = Math.ceil(Math.max(...i, C));
            f({
                isMeasuring: !1,
                buttonWidth: a
            });
        }
    }, [
        s.isMeasuring
    ]);
    const n = o.useMemo(()=>O(()=>{
            f({
                isMeasuring: !0,
                buttonWidth: 0
            });
        }, 5, {
            maxWait: 50
        }), []);
    P(c.current, n), z(n), o.useEffect(()=>(window.addEventListener("resize", n), window.addEventListener("focus", n), document.addEventListener("visibilitychange", n), ()=>{
            window.removeEventListener("resize", n), window.removeEventListener("focus", n), document.removeEventListener("visibilitychange", n);
        }), [
        n
    ]);
    const g = o.Children.toArray(t).sort((i, a)=>{
        const d = p.indexOf(i.type), E = p.indexOf(a.type);
        return d - E;
    }), l = /* @__PURE__ */ W("div", _object_spread_props(_object_spread({
        ref: c,
        className: h(R, S[e], s.buttonWidth ? e === "full-width" ? k : A : D, {
            [I]: v > 1
        }),
        style: w({
            [T.buttonWidth]: s.buttonWidth ? `${s.buttonWidth}px` : "auto"
        })
    }, N(b, "ButtonLayout")), {
        children: [
            r ? /* @__PURE__ */ m("div", {
                className: h(V, {
                    [_]: e === "left"
                }),
                "data-link": "true",
                children: r
            }) : null,
            g
        ]
    }));
    return u ? /* @__PURE__ */ m("div", {
        className: j,
        children: l
    }) : l;
}, Y = F;
export { Y as default };
